import { FC, SVGProps } from 'react'

export const Water: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.0332 5.51261C12.021 5.51944 12.0049 5.53194 11.989 5.55936C11.2593 6.81574 10.1217 8.83184 9.16864 10.7722C8.69172 11.7432 8.26704 12.6831 7.96327 13.4925C7.64919 14.3293 7.5 14.9367 7.5 15.2801C7.5 17.3374 9.45138 19.1752 12.0833 19.1752C14.7153 19.1752 16.6667 17.3374 16.6667 15.2801C16.6667 14.9367 16.5175 14.3293 16.2034 13.4925C15.8996 12.6831 15.475 11.7432 14.998 10.7722C14.045 8.83184 12.9074 6.81574 12.1777 5.55936C12.1618 5.53194 12.1457 5.51944 12.1335 5.51261C12.1195 5.50478 12.1023 5.5 12.0833 5.5C12.0644 5.5 12.0472 5.50478 12.0332 5.51261ZM10.6919 4.80599C11.3161 3.73134 12.8506 3.73133 13.4748 4.80599C14.2111 6.07369 15.3687 8.1245 16.3444 10.1109C16.8318 11.1033 17.2799 12.0918 17.6077 12.9654C17.9253 13.8115 18.1667 14.6417 18.1667 15.2801C18.1667 18.3537 15.3424 20.6752 12.0833 20.6752C8.82425 20.6752 6 18.3537 6 15.2801C6 14.6417 6.24136 13.8115 6.55892 12.9654C6.88679 12.0918 7.33485 11.1033 7.82228 10.1109C8.79794 8.1245 9.95559 6.07369 10.6919 4.80599Z"
			fill="currentColor"
		/>
	</svg>
)
